
import { defineComponent } from 'vue'
import { mapActions } from 'vuex'
import { Snack } from 'vue-common'
import { IdleTimeoutWarning } from 'vue-common/src/components'

import Header from '@/components/Header.vue'

export default defineComponent({
  name: 'App',
  components: { Snack, Header, IdleTimeoutWarning },
  methods: {
    ...mapActions({ getMe: 'user/getMe' })
  },
  async created() {
    await this.getMe()
  }
})
